import { createContext, useContext, ReactNode } from "react";
import { useTheme as useThemeHook, type Theme, type ResolvedTheme } from "@/hooks/useTheme";

type ThemeContextValue = {
  theme: Theme;
  setTheme: (t: Theme) => void;
  resolvedTheme: ResolvedTheme;
};

const ThemeContext = createContext<ThemeContextValue | null>(null);

export function ThemeProvider({ children }: { children: ReactNode }) {
  const value = useThemeHook();
  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export function useThemeContext(): ThemeContextValue {
  const ctx = useContext(ThemeContext);
  if (!ctx) {
    // Fallback seguro: instancia um hook local (usado por componentes fora do provider, ex.: sonner)
    // Em prática, App.tsx envolve tudo com ThemeProvider.
    throw new Error("useThemeContext deve ser usado dentro de <ThemeProvider>");
  }
  return ctx;
}
